import React from 'react';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import './App.css';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import Page from "./Page/Page";
import { StateProvider } from './store.js';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import {AppErrorBoundary} from "./ErrorBoundary";

const queryClient = new QueryClient();

const outerTheme = createTheme({
  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  primaryColour: '#1866b8',
  primaryBackgroundColour: '#f2f4ff',
  secondaryColour: '#f2f4ff',
  backgroundColour: '#f5f7fc',
  warnColor:'#b53d47',
  textColour: '#333',
  palette: {
    primary:{
      main: '#1866b8',
    },
    secondary: {
      main: '#f2f4ff',
    },
    error: {
      main: '#b53d47'
    }
  }
});

function App() {
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
          <MuiThemeProvider theme={outerTheme}>
            <StylesThemeProvider theme={outerTheme}>
              <StateProvider>
               <Router>
                 <Page />
               </Router>
              </StateProvider>
            </StylesThemeProvider>
          </MuiThemeProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
}

export default App;
